export default __webpack_public_path__ + "static/media/stanton-logo.1626e964.png";